import { render, staticRenderFns } from "./UpointLogin.vue?vue&type=template&id=103c73ca&"
import script from "./UpointLogin.vue?vue&type=script&lang=js&"
export * from "./UpointLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports